export default {
    API_PATH: "/api"
}